export default __webpack_public_path__ + "tds-white-icon.svg";